var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"no-underline hover:no-underline font-bold text-2xl lg:text-4xl px-6 py-2 task-text",class:_vm.classList,attrs:{"href":"/"}},[_vm._v("Trackee ")])}
var staticRenderFns = []

export { render, staticRenderFns }